import React from "react";

export default function Grain() {
  return <div className="grain" aria-hidden="true" data-testid="grain-overlay" />;
}
